<template>
  <div class="autocomplete">
        <div class="row">
            <div class="input-field col s12">
                <i class="material-icons prefix">shopping_cart</i>
                <input :id="placeholder.replace(/\s/g, '')" type="text" v-model="search" @input="onChange" autocomplete="off" />
                <label :for="placeholder.replace(/\s/g, '')">{{ placeholder }}</label>
                <ul v-show="isOpen" class="autocomplete-results">
                    <li v-for="(result, i) in results" :key="i" @click="setResult(result)" class="autocomplete-result">
                        {{ result.label }}
                    </li>
                </ul>
            </div>
        </div>
  </div>
</template>

<script>
  export default {
    name: 'autocomplete',
    props: {
      items: {
        type: Array,
        required: false,
        default: () => [],
      },
      placeholder: {
          type: String,
          required: true
      }
    },
    data() {
      return {
        search: '',
        results: [],
        result: {},
        isOpen: false,
      };
    },
    methods: {
      onChange() {
        this.isOpen = true;
        this.filterResults();
      },
      filterResults() {
        this.results = this.items.filter(item => item.label.toLowerCase().indexOf(this.search.toLowerCase()) > -1);
      },
      setResult(result) {
          this.result = result;
        this.search = result.label;
        this.isOpen = false;
        this.$emit('selected', result);
      },
    }
  };
</script>

<style>
  .autocomplete {
    position: relative;
    /* width: 130px; */
  }

  .autocomplete-results {
    padding: 0;
    margin: 0;
    border: 1px solid #eeeeee;
    height: 120px;
    overflow: auto;
  }

  .autocomplete-result {
    list-style: none;
    text-align: left;
    padding: 4px 2px;
    cursor: pointer;
  }

  .autocomplete-result:hover {
    background-color: #4AAE9B;
    color: white;
  }
</style>


// WEBPACK FOOTER //
// src/components/shared/autocomplete/Autocomplete.vue